import { render, staticRenderFns } from "./SortFilterSection.vue?vue&type=template&id=82362968&"
import script from "./SortFilterSection.vue?vue&type=script&lang=js&"
export * from "./SortFilterSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports